module.exports = __webpack_public_path__ + "img/infooo.43e699cb.png";